import React, { useMemo } from "react";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import useLanguageChange from "../../../../hooks/useLanguageChange";
import { setCurrentSpeakerDevice } from "../../../../reducers/call-setting-reducer";
import { MEDIA_PERMISSIONS } from "../../../../constants/CallSettingConstants";
import { LogFirebase } from "../../../../services/firestore";

const SpeakerDropDown = ({ askPermission }) => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();

    const { isMicExist, audioPermission, speakerDevices, currentSpeakerDevice } = useSelector((state) => state.callSetting);

    const handleSpeakerDeviceChange = (device) => {
        dispatch(setCurrentSpeakerDevice(device));
        LogFirebase("CallSettings", "selectedSpeaker", device.label);
    };

    const speakerLabelText = useMemo(() => {
        let text = "";
        if (audioPermission === MEDIA_PERMISSIONS.GRANTED && speakerDevices.length === 0) {
            text = localisedValues["default_label"];
        } else if (audioPermission === MEDIA_PERMISSIONS.PROMPT) {
            text = localisedValues["grant_permission"];
        } else if (audioPermission === MEDIA_PERMISSIONS.ERROR || audioPermission === MEDIA_PERMISSIONS.BLOCKED) {
            text = localisedValues["speakers_blocked"];
        } else if (audioPermission === MEDIA_PERMISSIONS.GRANTED) {
            text = currentSpeakerDevice?.label;
        }

        return text;
    }, [isMicExist, audioPermission, currentSpeakerDevice, speakerDevices, localisedValues]);

    const onClickPermissionDropdown = () => {
        if (
            audioPermission === MEDIA_PERMISSIONS.PROMPT ||
            audioPermission === MEDIA_PERMISSIONS.ERROR ||
            audioPermission === MEDIA_PERMISSIONS.BLOCKED
        ) {
            askPermission();
        }
    };

    return (
        <div className='form-group'>
            <label className='form-label'>{localisedValues["speakers"]}</label>
            <div className='dropdown custom-dropdown dropdown-select call-settings-dropdown'>
                <button
                    className='btn dropdown-toggle triangle-none'
                    type='button'
                    aria-expanded='false'
                    data-bs-toggle={audioPermission === MEDIA_PERMISSIONS.GRANTED && "dropdown"}
                    disabled={
                        audioPermission === MEDIA_PERMISSIONS.ERROR ||
                        audioPermission === MEDIA_PERMISSIONS.BLOCKED ||
                        (audioPermission === MEDIA_PERMISSIONS.GRANTED && speakerDevices.length === 0)
                    }
                    onClick={onClickPermissionDropdown}
                >
                    <span className='btn-text'>{speakerLabelText}</span>
                    <span className='dropdown-toggle-arrow icon-down-arrow-light'></span>
                </button>
                {audioPermission === MEDIA_PERMISSIONS.GRANTED && (
                    <div className='dropdown-menu'>
                        <div className='dropdown-menu-in custom-scroll-thin'>
                            <ul>
                                {speakerDevices.map((speaker) => {
                                    return (
                                        <li key={speaker.deviceId}>
                                            <button
                                                className={clsx("btn dropdown-item", speaker.deviceId === currentSpeakerDevice?.deviceId && "active")}
                                                onClick={() => handleSpeakerDeviceChange(speaker)}
                                            >
                                                {speaker.label}
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

SpeakerDropDown.propTypes = {
    askPermission: PropTypes.func,
};

export default SpeakerDropDown;
